// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc38ca1b","455":"1b24f417","977":"b6e044ce"}[chunkId] + ".chunk.js";
};